module.exports = __webpack_public_path__ + "img/sub-nav-links-lincoln.daefeb84.png";